export interface IUserView {
        userId: number;
        firstName: string;
        lastName: string;
        enabled: boolean;
        range: number;
        addressLine1: string;
        addressLine2: string;
        city: string;
        zipCode: string;
        state: string;
        country: string;
    }

    export class UserView implements IUserView {
        userId: number;
        firstName: string;
        lastName: string;
        enabled: boolean;
        range: number;
        addressLine1: string;
        addressLine2: string;
        city: string;
        zipCode: string;
        state: string;
        country: string;
    }